import { Badge, Button, Card, Icon } from '../../design-system/index.js'
import { SCHOLARSHIPS } from '../../content/landing'
import { sectionGap, wrap } from '../layout.js'
import SectionHead from './SectionHead.jsx'

/** Scholarships closing this month — three hoverable cards. */
export function Scholarships({ t, desktop, authHref, signedIn = false }) {
  return (
    <section
      id="scholarships"
      aria-labelledby="scholarships-title"
      style={{ ...wrap(desktop), paddingTop: sectionGap(desktop) }}
    >
      <SectionHead
        id="scholarships-title"
        label={t.schLabel}
        title={t.schTitle}
        sub={t.schSub}
        desktop={desktop}
      />
      <ul
        style={{
          display: 'grid',
          gridTemplateColumns: desktop ? '1fr 1fr 1fr' : '1fr',
          gap: 16,
          margin: `${desktop ? 40 : 28}px 0 0`,
          padding: 0,
          listStyle: 'none',
        }}
      >
        {SCHOLARSHIPS.map((s) => (
          <Card as="li" key={s.name} hoverable className="u-sch" size="lg">
            {/* The badge row is pushed to the bottom of the card so the three
                line up even when a name wraps onto a second line. */}
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: 10, height: '100%' }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  gap: 8,
                }}
              >
                <h3 style={{ fontSize: 20, margin: 0, letterSpacing: '-0.02em' }}>{s.name}</h3>
                <Badge tone="verified">
                  <Icon name="check" size={13} />
                  {t.verified}
                </Badge>
              </div>
              <p style={{ fontSize: 14, color: 'var(--ink-2)', margin: '0 0 4px' }}>{s.region}</p>
              <div
                style={{
                  marginTop: 'auto',
                  display: 'flex',
                  gap: 8,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <Badge tone="info">{t.fund}</Badge>
                <Badge tone="deadline">
                  <Icon name="clock" size={13} />
                  {t.deadline}: {s.deadline}
                </Badge>
                <span style={{ fontSize: 13, color: 'var(--ink-3)' }}>
                  {s.daysLeft} {t.previewDaysLeft}
                </span>
              </div>
            </div>
          </Card>
        ))}
      </ul>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 28 }}>
        <Button variant="secondary" full={!desktop} href={authHref}>
          {signedIn ? t.openCabinet : t.schCta}
        </Button>
      </div>
    </section>
  )
}

export default Scholarships
